import { defineMessages, useIntl } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { Button } from '~/eds/src/components/Button/Button';
import { Theme } from '~/eds/src/types/Theme';

import { useSidebarNavPreference } from './SidebarNavPreferenceContext';

const messages = defineMessages({
  tryLabel: {
    id: 'SidebarNavOptIn.tryLabel',
    defaultMessage: 'Try new navigation',
    description:
      'Primary label for the opt-in control that enables the sidebar navigation preview.',
  },
  tooltip: {
    id: 'SidebarNavOptIn.tooltip',
    defaultMessage:
      'Try the redesigned sidebar navigation. You can switch back any time.',
    description: 'Tooltip explaining the sidebar navigation preview control.',
  },
});

interface SidebarNavOptInToggleProps {
  /** Matches the surrounding navbar theme so the label stays legible on both. */
  theme?: Theme;
}

export function SidebarNavOptInToggle({ theme }: SidebarNavOptInToggleProps) {
  const intl = useIntl();
  const { optIn } = useSidebarNavPreference();

  return (
    <Box className="sidebar-nav-opt-in">
      <Button
        // `ghost` is the only subdued variant with a dark-theme style, so it is
        // what keeps this invitation quiet on both navbars.
        level="ghost"
        size="s"
        text={intl.formatMessage(messages.tryLabel)}
        theme={theme}
        tooltip={intl.formatMessage(messages.tooltip)}
        onClick={optIn}
      />
    </Box>
  );
}
